module.exports = __webpack_public_path__ + "img/computer.4255e0d8.png";